import { createContext, useContext, useLayoutEffect, useState } from "react";

const NavbarThemeContext = createContext({
  theme: "default",
  setTheme: () => {},
});

export const useNavbarTheme = () => useContext(NavbarThemeContext);

export const NavbarThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState("default");

  return (
    <NavbarThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </NavbarThemeContext.Provider>
  );
};

export const NavbarTheme = ({ theme }) => {
  const { setTheme } = useNavbarTheme();

  useLayoutEffect(() => {
    setTheme(theme);

    return () => setTheme("default");
  }, [theme, setTheme]);

  return null;
};
